import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-documentator',
  templateUrl: './documentator.component.html',
  styleUrls: ['./documentator.component.css']
})
export class DocumentatorComponent {
  safeUrl: SafeResourceUrl;
  usuario: string = JSON.parse(sessionStorage.getItem('user'));
  imulodbc: string = '';
  sNumSol: string = '';
  report: any = null;
  origin: 'SOL' | 'OPE' = null;
  reportName: string = '';
  operacion: string = '';
  baseDomain: string;

  constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute) {
    const url = '';
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

    // Determinar el dominio base según el clientType
    switch (environment.clientType) {
      case 'cafam':
        this.baseDomain = 'devcafam.datascoring.co';
        break;
      case 'cafamQA':
        this.baseDomain = 'qacafamaws.datascoring.co';
        break;
      case 'cafamPROD':
        this.baseDomain = 'prdcafam.datascoring.co';
        break;
      default:
        this.baseDomain = 'devcafam.datascoring.co'; // Fallback a desarrollo
        break;
    }

    // Obtener el valor del parámetro 'id' de la URL
    this.route.queryParams.subscribe((params) => {
      this.imulodbc = params['imulodbc'];
      this.sNumSol = params['cliente'];
      this.report = params['reportId'];
      this.origin = params['origin'];
      this.reportName = params['reportName'];
      this.operacion = params['operacion'];

      this.buildURL(this.imulodbc, this.sNumSol, this.report, this.origin, this.reportName, this.operacion);
    });
  }

  buildURL(imulodbc, sNumSol, report, origin, reportName, operacion) {

    if (origin === 'OPE') {
      const url = `https://${this.baseDomain}/seed/SeedImprime2.aspx?1=1&imulodbc=${imulodbc}&modulo=2&operacion=${operacion}&cliente=${sNumSol}&Reporte=${report}`;
      console.log('url', url);
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    } else if (origin === 'SOL') {
      const url = `https://${this.baseDomain}/seed/SeedImprime2.aspx?1=1&imulodbc=${imulodbc}&modulo=9&operacion=&cliente=${sNumSol}&Reporte=${report}`;
      console.log('url', url);
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
  }

  ngOnInit() {}

  goBack() {
    window.history.back();
  }
}
